export default "__VITE_ASSET__bHSpeBdt__"